var SearchOptionsItem = require('./search-options/search-options-item');
var SearchOptions = Marionette.CollectionView.extend({
    tagName: 'select',
    className: 'fmcy-search-options form-control',
    events: {
        change: 'optionSelected'
    },
    initialize: function (options) {
        this.options = _.defaults(
            options || {},
            {
            }
        );
    },
    onBeforeShow: function() {
        this.selectedModel = this.collection.at(0);
    },
    optionSelected: function(event) {
        this.selectedModel = this.collection.get(
            event.currentTarget.selectedOptions[0].id
        );
        this.trigger('search:option:selected', this.selectedModel);
    },
    template: function() {
        return '';
    },
    childView: SearchOptionsItem
});
module.exports = SearchOptions;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/subfilters/search-options.js
 **/